module.exports = __webpack_public_path__ + "static/img/logo.52a17551.png";